import { Component, OnInit } from '@angular/core';
import { CuentasPorPagarService } from '../../services/cuentas-por-pagar.service';
import { ProveedoresService } from '../../services/proveedores.service';
import { ObrasService } from '../../services/obras.service';
import { AutenticacionService, ModulosARK, TipoPermiso } from '../../services/autenticacion.service';

@Component({
  selector: 'app-gastos',
  templateUrl: './gastos.component.html',
  styleUrls: ['./gastos.component.scss']
})
export class GastosComponent implements OnInit {

    public errors: any = {};
    public puntosINPC: any [] = [];
    public unidadesIncremento: any [] = [];
    public gastos: any [] = [];
    public modeFormulario: string = 'readonly';
    public gastoSelected: number = null;
    public estatusPago: any [] = [];

    //Base component
    public permitirEditarGasto: boolean = false;

    //Filters
    public obraSelected: any = {};
    public proveedorSelected: any = {};
    public page: number = 1;
    public estatusPagoSelected: any = {};

    //Helpers
    private loading: boolean = false;
    public obras: any [] = [];
    public proveedores: any [] = [];
    public loading_obras: boolean = false;
    public loading_proveedores: boolean = false;

    //Paginacion
    public paginate: any = {};

    constructor(
        private gastosService: CuentasPorPagarService,
        private obrasService: ObrasService,
        private proveedoresService: ProveedoresService,
        private authService: AutenticacionService
    ) {
    }

    ngOnInit() {
        this.setupControl();
    }

    public setupControl(){
        this.loadGastos();
        this.loadObras();
        this.loadProveedores();
        this.loadEstatusPago();
        this.permitirEditarGasto = this.authService.tienenPermisos(ModulosARK.Gastos, TipoPermiso.Escritura);
    }

    public changeObra(event){
        this.obraSelected = event;
    }

    public changeProveedor($event){
        this.proveedorSelected = $event;
    }

    public changeEstatusPago($event){
        this.estatusPagoSelected = $event;
    }

    public addGasto(){
        this.gastoSelected = null;
        this.modeFormulario = 'add';
    }

    public gastoGuardado(){
        this.modeFormulario = 'readonly';
        this.gastoSelected = null;
        this.loadGastos();
    }

    public accionCancelada(){
        this.modeFormulario = 'readonly';
    }

    public selectGasto(gasto){
        this.gastoSelected = gasto.id_gasto;
        this.modeFormulario = 'edit';
    }

    private loadGastos(){
        this.loading = true;
        let filters = this.getFiltes();

        this.gastosService.getGastos(filters)
        .subscribe(response => {
            let content = response.json().content;
            this.gastos = content.data;
            this.setupPagination(content);
            this.loading = false;
        },error=>{
            console.log("Error loading gastos: ", error);
            this.loading = false;
            // Check if it's an HTML error response (like 404 or 500)
            if (error.status === 404) {
                console.log("Gastos endpoint not found - this might be expected if the API is not fully implemented");
                this.gastos = [];
            } else if (error.status === 500) {
                console.log("Server error when loading gastos");
                this.gastos = [];
            } else {
                console.log("Unexpected error when loading gastos: ", error.status);
                this.gastos = [];
            }
        });
    }

    private loadEstatusPago(){
        let arrayEstatusPago = [
            {
                estatus: 'PENDIENTE'
            },
            {
                estatus: 'PRE-AUTORIZADO'
            },
            {
                estatus: 'AUTORIZADO'
            },
            {
                estatus: 'PAGADO'
            }
        ];
        this.estatusPago = arrayEstatusPago;
    }

    // MAIN SECTIONS FUNCTIONS     
    writePermission() {
        return true;
    }

    canExport() {
        return true;
    }

    /**
     * Utilities
     */
    
    private getFiltes(){
        let filters = {
            id_obra: (this.obraSelected && this.obraSelected.idObras) ?  this.obraSelected.idObras : null,
            id_proveedor: (this.proveedorSelected && this.proveedorSelected.idProveedores) ?  
                this.proveedorSelected.idProveedores : null,
            page: this.page,
            estatusPago: (this.estatusPagoSelected) ?  this.estatusPagoSelected.estatus : null
        }

        return filters;
    }

    
    private loadObras(){
        this.loading_obras = true;
        this.obrasService.getObratoSelect('')
        .subscribe((response) => {
            this.obras = response.json().content;
            this.loading_obras = false;
        },error=>{
            console.log("Error loading obras: ", error);
            this.obras = [];
            this.loading_obras = false;
        });
    }

    private loadProveedores(){
        this.loading_proveedores = true;
        this.proveedoresService.getProveedorestoSelect()
        .subscribe(response => {
            let content = response.json().content;
            this.proveedores = content.proveedores || content;
            this.loading_proveedores = false;
        },error=>{
            console.log("Error loading proveedores: ", error);
            this.proveedores = [];
            this.loading_proveedores = false;
        });
    }

    private setupPagination(content){
        this.paginate.first_item = content.from;
        this.paginate.last_item = content.to;
        this.paginate.last_page = content.last_page;
        this.paginate.per_page = content.per_page;
        this.paginate.total_items = content.total;
        this.paginate.current_page = content.current_page;
    
        this.paginate.pages = [];
        for(let i = 1; i <= this.paginate.last_page; i++){
          this.paginate.pages.push({
            'number': i,
            'label': i
          });
        }
    }

    public pageChanged(event: any): void {
        if(event.page !== undefined && event.page != this.page)
        {  
            this.page = event.page;
        }

        this.loadGastos();
    }   
}


// WEBPACK FOOTER //
// ./src/app/components/gastos/gastos.component.ts